var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-icon"},[(_vm.to)?_c('router-link',{attrs:{"to":_vm.to,"aria-label":"Planet Farms Logo"}}):_c('span',{on:{"click":function($event){return _vm.$emit('click', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }